import { render, staticRenderFns } from "./Unregistered.vue?vue&type=template&id=10518693&"
import script from "./Unregistered.vue?vue&type=script&lang=js&"
export * from "./Unregistered.vue?vue&type=script&lang=js&"
import style0 from "./Unregistered.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Unregistered.vue"
export default component.exports